module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_05_770_280_vi-d3a1df353e694736b32f7253ff732105.jpg";